export default __webpack_public_path__ + "static/media/pc_logo_white.f64b6c65.png";